import React from 'react';
import Spinner from 'react-bootstrap/Spinner'
import './style.css';

function ActivityIndicator(props) {
    return (
        <div className={props.theme} style={{ marginTop: "5px" }}>
            <Spinner animation="border" className={props.themeSpinner !== undefined && props.themeSpinner !== null ? props.themeSpinner : null}  />
        </div>
    );
}

export default ActivityIndicator
